import ReactDOM from 'react-dom/client';
// import App from './App';
import '@fontsource/ibm-plex-sans/300.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import './index.css';
import './styles/eduBox.css';
import './styles/scrollbar.css';
import './styles/playbook-properties-header.css';
import { router } from './routes.tsx';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { autoCleanupStorage } from './utils/labsStorageCleanup';

// Detect non-Mac systems and add a class to the body for custom scrollbar styling
const isMacOS = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
if (!isMacOS) {
  document.body.classList.add('non-mac');
}

// Auto-cleanup old localStorage entries on app startup
autoCleanupStorage();

// Temporarily remove StrictMode to test verification flow
ReactDOM.createRoot(document.getElementById('root')!).render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
);
